// Kill ALL automatic scrolling from theme.js.
// Runs synchronously before theme.js (which is type="module" = deferred).
(function() {
  Element.prototype.scrollIntoView = function() {};

  var _scrollTo = window.scrollTo.bind(window);
  var _scroll = window.scroll.bind(window);
  var allowScroll = false;

  window.scrollTo = function() {
    if (allowScroll) { allowScroll = false; return _scrollTo.apply(window, arguments); }
  };
  window.scroll = function() {
    if (allowScroll) { allowScroll = false; return _scroll.apply(window, arguments); }
  };
  window.__safeScrollTo = function(x, y) {
    allowScroll = true;
    _scrollTo(x, y);
  };

  var _focus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(opts) {
    _focus.call(this, Object.assign({}, opts, { preventScroll: true }));
  };
})();

(function() {
  function init() {
    var dialog = document.getElementById('FilterDialogMobile');
    if (!dialog) return;

    // Use event delegation on document so clicks work even after AJAX
    // re-renders replace the MobileFilterToggle button in the DOM.
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('#MobileFilterToggle');
      if (btn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!dialog.open) dialog.showModal();
      }
    }, true);

    // Close button — use delegation too in case dialog content re-renders
    dialog.addEventListener('touchend', function(e) {
      if (e.target.closest('#MobileFilterClose')) {
        e.preventDefault();
        dialog.close();
      }
    });
    dialog.addEventListener('click', function(e) {
      // Close on X button
      if (e.target.closest('#MobileFilterClose')) {
        e.preventDefault();
        dialog.close();
        return;
      }
      // Close on backdrop click
      if (e.target === dialog) {
        dialog.close();
      }
    });

    // VIEW RESULTS — delegation
    dialog.addEventListener('click', function(e) {
      if (e.target.closest('#MobileFiltersApply')) {
        var form = document.getElementById('FiltersFormMobile');
        if (form) {
          var formData = new FormData(form);
          var searchParams = new URLSearchParams(formData).toString();
          var url = window.location.pathname + (searchParams ? '?' + searchParams : '');
          window.location.href = url;
        }
      }
    });

    // Desktop: keep filter panels expanded after AJAX re-render
    // and restore scroll position.
    var productFilters = document.querySelector('loess-product-filters');
    if (productFilters) {
      var savedScrollY = 0;

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'loading') {
            if (productFilters.hasAttribute('loading')) {
              savedScrollY = window.scrollY || window.pageYOffset;
            } else {
              var panels = document.querySelectorAll('#FilterDrawerLarge loess-collapsible-panel');
              for (var j = 0; j < panels.length; j++) {
                panels[j].setAttribute('open', '');
              }
              var pos = savedScrollY;
              requestAnimationFrame(function() {
                window.__safeScrollTo(0, pos);
              });
            }
            break;
          }
        }
      });
      observer.observe(productFilters, { attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
